import { cn } from "@/lib/cn";
import { Icons } from "@/components/ui/icons";

/**
 * Workshop: Contact section for Settings.
 * Static link list with LinkedIn, email, and website.
 */

interface ContactLink {
  id: string;
  label: string;
  href: string;
  icon: React.ReactNode;
  testId: string;
}

const CONTACT_LINKS: ContactLink[] = [
  {
    id: "linkedin",
    label: "LinkedIn",
    href: "https://linkedin.com/company/denker-ai",
    icon: <Icons.Linkedin className="h-4 w-4" />,
    testId: "contact-link-linkedin",
  },
  {
    id: "support-denker-ai",
    label: "support@denker.ai",
    href: "mailto:support@denker.ai",
    icon: <Icons.Mail className="h-4 w-4" />,
    testId: "contact-link-support-denker-ai",
  },
  {
    id: "denker-ai",
    label: "denker.ai",
    href: "https://denker.ai",
    icon: <Icons.Globe className="h-4 w-4" />,
    testId: "contact-link-denker-ai",
  },
];

interface ContactSectionProps {
  className?: string;
  "data-testid"?: string;
}

export function ContactSection({
  className,
  "data-testid": testId = "settings-contact",
}: ContactSectionProps) {
  return (
    <div className={cn("flex flex-col gap-1", className)} data-testid={testId}>
      {CONTACT_LINKS.map((link) => (
        <a
          key={link.id}
          href={link.href}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-3 rounded-lg px-3 py-2.5 text-secondary transition-colors hover:bg-btn-ghost-fill hover:text-primary"
          data-testid={link.testId}
        >
          {link.icon}
          <span className="flex-1 text-[11px]">{link.label}</span>
          <Icons.ExternalLink className="ml-auto h-3.5 w-3.5 text-muted" />
        </a>
      ))}
    </div>
  );
}

export type { ContactSectionProps };
